import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";

export class GetProductRemainingResponse {
    remaining: number;
}

export function getProductRemaining(product_id: string, price_id: string, options: string[]): Promise<AxiosResponse<GetProductRemainingResponse>>{
    // let populate_string = '';
    // populate.forEach(e => {
    // 	populate_string += `populate[]=${e}&`
    // })
    const query = `/product/${product_id}/remaining?${price_id?`price_id=${price_id}&`:''}${options.map(option => `options[]=${option}`).join('&')}`;
    return Cirus.get(query);
}